import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DataUtil } from '@syncfusion/ej2-data';
import { DemoService } from './../../../demo.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
// import { Observable } from 'rxjs/Observable';

import { DateAgoPipe } from './../../../pipes/date-ago.pipe';

@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.css']
})
export class TodoComponent implements OnInit {

  title = 'todo';

  filter: 'all' | 'active' | 'done' = 'all';

  allItems = [
    // { description: 'eat', done: true },
    // { description: 'sleep', done: false },
    // { description: 'play', done: false },
    // { description: 'laugh', done: false },
  ];
  user_todos: Object;
  get_latest_todo_id: Object;
  user_todo_results: any;

  today = new Date();

  constructor(public _demoService: DemoService, public gfunc: GlobalFunctionsService,  public datepipe: DatePipe) { }

  ngOnInit() {
    this.getUserToddos(this.gfunc.sessionUserId);
  }
  // https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Client-side_JavaScript_frameworks/Angular_todo_list_beginning
  get items() {
    // this.getUserToddos(this.gfunc.sessionUserId);
    if (this.filter === 'all') {
      return this.allItems;
    }
    // return this.allItems.filter((item) => this.filter === 'done' ? item.done : !item.done);
    return this.allItems.filter((item) => this.filter === 'done' ? (item.done === 'true') : (item.done === 'false'));
    // obj => obj.subject_id === subject_id)
  }

  addItem(description: string) {
    let model = [];
    this.allItems.unshift({
      description,
      done: 'false',
      user_id: this.gfunc.sessionUserId,
      created_date: this.today
      // todo_id: ''
    });

    this.createUserTodo( this.allItems[0]); // insert the first item after unshift. (or maybe insert first. and setup a new model.)
  }


  remove(item) {
    // console.log('remve todo id: ' + item.todo_id);
    this.deleteUserTodo(item.todo_id, this.gfunc.sessionUserId);
    this.allItems.splice(this.allItems.indexOf(item), 1);

  }



  getUserToddos(user_id) {
    this._demoService.getUserTodos(user_id).subscribe(
       data => { this.user_todos = data;
        let res = data[0];

        this.user_todo_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_items = Object.keys(this.user_todos).length;
  // now loop and push to join model
  for(let i=0;i < count_items; i++) {
    let res = this.user_todo_results[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
  this.allItems.push({
...res
    });
  
  } // end brands loop.
  this.allItems = this.allItems;
  // console.log('AllItems: ' + JSON.stringify(this.allItems));

        // this.model.subject_number = res.subject_id;
        // this.model.job_reference_number = res.job_reference_number;
        // this.model.file_number = res.file_number;
        // this.model.reference_number = res.reference_number;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   createUserTodo(model) {
    // this.model.subject_id = this.subject_id;
    // this.model.job_id = this.job_id;
    // this.model.created_by = this.sessionUserId;

    // look up subject data and insert into model. (add addition fields by adding to note model)
   // this.getJobSubject(this.subject_id);
  
    this._demoService.createUserTodo(model).subscribe(
         data => {  this.get_latest_todo_id = data; // this is the retuned json upon creation.
          // this.getTraceCandidateNotes(this.trace_candidate_id);

         // CreateJob3Component.getTraceCandidateNotes();

         // CreateJob3Component.returned.next(false);
          // this.toastr.info('Note Added To Your Subject!');
          // this.allItems = []; // empty first..
          // this.getUserToddos(this.gfunc.sessionUserId);

           //  return true;
         },
         error => {
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
         }
    );

          this.allItems = []; // empty first..
          this.getUserToddos(this.gfunc.sessionUserId);

    }

    deleteUserTodo(todo_id, user_id) {
      // if (confirm('Are you sure you want to delete? ')) {
        this._demoService.deleteUserTodo(todo_id, user_id).subscribe(
           data => {
             // this.getTraceNotes(this.trace_id);
            // this.refreshList();
            this.allItems = []; // empty first..
            this.getUserToddos(this.gfunc.sessionUserId);
             return true;
           },
           error => {
             console.error('Error deleting your to do item!');
            //  return Observable.throw(error);
           }
        );
    // }
    }



    updateUserTodo(model){
      this._demoService.updateUserTodo(model).subscribe(
        data => { // this.trace_candidate_update = data;
        // this.toastr.success('Subject Status Updated');
        // const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
        // this.search_results[objIndex].updated_status = 'yes';
        this.allItems = []; // empty first..
        this.getUserToddos(this.gfunc.sessionUserId);
        },
        error => {
          // this.toastr.error('Error Changing Status of Subject');
          // return Observable.throw(error);
        }
    );
    } // end if open

}
